export default __webpack_public_path__ + "static/media/intelligence.11bd2ab2.svg";